import baseStyles from '../Base/Base.styles'

export default ({
  base,
  panelBgColor, 
  panelTitleTextColor, 
  panelContentTextColor, 
  panelIconColor, 
  activePanelBgColor, 
  activePanelTitleTextColor, 
  activePanelIconColor,
  activePanelContentBgColor
}) => {

  const jss = {root: {
    ...baseStyles(base),
    '--panel-bg-color': panelBgColor,
    '--panel-title-text-color': panelTitleTextColor,
    '--panel-content-text-color': panelContentTextColor,
    '--panel-icon-color': panelIconColor, 
    '--active-panel-bg-color': activePanelBgColor,
    '--active-panel-title-text-color': activePanelTitleTextColor,
    '--active-panel-icon-color': activePanelIconColor,
    '--active-panel-content-bg-color': activePanelContentBgColor
  }}

  return jss
}